import axios from "axios";
import { toast } from "react-toastify";
import { handleErrors } from "./handleError";

export default function Api({ set_login_action, set_loading_action }) {
  set_loading_action(true);

  const Api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    withCredentials: true,
    xsrfHeaderName: "X-XSRF-TOKEN",
  });

  Api.interceptors.response.use(
    (response) => {
      set_loading_action(false);

      if (response.data.message) {
        toast.success(response.data.message);
      }

      return Promise.resolve(response);
    },
    (error) => {
      if (
        error.response.status === 401 ||
        error.response.data.message === "Unauthenticated."
      ) {
        set_login_action(false);
        localStorage.removeItem("token");
        toast.error("Unauthenticated");
      } else {
        handleErrors(error);
      }

      set_loading_action(false);
      return Promise.reject(error);
    }
  );

  return Api;
}
